import {Component, inject} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {TranslationService} from '../../../core/services/translation.service';
import {RevocationService} from '../../../data/services/revocation.service';
import {NavigationCommand, NavigationService} from '../../../data/services/navigation.service';
import {SnackbarService} from "../../../core/services/snackbar.service";

@Component({
  selector: 'app-revocation-without-login',
  templateUrl: './revocation-without-login.component.html',
  styleUrls: ['./revocation-without-login.component.scss']
})
export class RevocationWithoutLoginComponent {
  private formBuilder = inject(FormBuilder);
  private revocationService = inject(RevocationService);
  private router = inject(Router);
  translationService = inject(TranslationService);
  snackbarService = inject(SnackbarService);

  isLoading = false;
  errorsArr: string[] = [];

  identificationForm: FormGroup = this.formBuilder.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    orderNo: ['', Validators.required]
  });

  onSubmit(): void {
    if (this.identificationForm.invalid) {
      this.identificationForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    this.errorsArr = [];
    const formData = this.identificationForm.value;
    formData.idType = 'UNKNOWN';
    this.revocationService.sendUnauthorizedRevocation(formData).subscribe({
      next: () => {
        this.isLoading = false;
        this.snackbarService.openSnackbar(this.translationService.getTranslation('revocation_saved'))
        this.router.navigate([NavigationCommand.REVOCATIONWITHOUTLOGINAFTER], {state: {formData}});
      },
      error: () => {
        // Kein Feedback an den Nutzer ob Daten gefunden wurden – immer weiterleiten
        this.isLoading = false;
        this.router.navigate([NavigationCommand.REVOCATIONWITHOUTLOGINAFTER], {state: {formData}});
      }
    });
  }
}
